module.exports = __webpack_public_path__ + "static/media/edge.6c44786f.svg";